import { Injectable } from '@angular/core';
import { EparcoursPath } from 'src/app/constantes/menu/menu-items/eparcours-path';
import { NavService } from './nav-service';
import { Navigator, NavigatorWith2Params, NavigatorWithParam, PARAM_TOKEN } from './navigators/navigators';

@Injectable({
  providedIn: 'root'
})
export class ParcoursNavService extends NavService{
  creation: Navigator = this.makeNavigator(EparcoursPath.root.PARCOURS, EparcoursPath.parcours.CREATION);
  creation_compose: Navigator = this.makeNavigator(EparcoursPath.root.PARCOURS, EparcoursPath.parcours.CREATION_COMPOSE);

  general: NavigatorWithParam<number> = this.makeNavigatorWithParam<number>(
    EparcoursPath.root.PARCOURS,
    EparcoursPath.parcours.EDITION,
    PARAM_TOKEN,
    EparcoursPath.parcours.EDITION_GENERAL,
  );


  contratsByIdSession: NavigatorWithParam<number> = this.makeNavigatorWithParam<number>(
    EparcoursPath.root.PARCOURS,
    EparcoursPath.parcours.EDITION,
    PARAM_TOKEN,
    EparcoursPath.parcours.CONTRATS,
  );

  creation_contrat = this.makeNavigatorWith2Params<number,number>(
    EparcoursPath.root.PARCOURS,
    PARAM_TOKEN,
    EparcoursPath.parcours.CREATION_CONTRAT,
    PARAM_TOKEN,
  );

  edition_contrat = this.makeNavigatorWith2Params<number,number>(
    EparcoursPath.root.PARCOURS,
    PARAM_TOKEN,
    EparcoursPath.parcours.EDITION_CONTRAT,
    PARAM_TOKEN,
  );

  edition_root: NavigatorWithParam<number> = this.makeNavigatorWithParam<number>(
    EparcoursPath.root.PARCOURS,
    EparcoursPath.parcours.EDITION,
    PARAM_TOKEN,
  );


  recherche: Navigator = this.makeNavigator(EparcoursPath.root.PARCOURS);

  inscriptionsByIdSession: NavigatorWithParam<number> = this.makeNavigatorWithParam<number>(
    EparcoursPath.root.PARCOURS,
    EparcoursPath.parcours.EDITION,
    PARAM_TOKEN,
    EparcoursPath.parcours.LISTE_INSCRIPTIONS,
  );

  documentsByIdSession: NavigatorWithParam<number> = this.makeNavigatorWithParam<number>(
    EparcoursPath.root.PARCOURS,
    EparcoursPath.parcours.EDITION,
    PARAM_TOKEN,
    EparcoursPath.parcours.DOCUMENTS,
  );

  facturesByIdSession: NavigatorWithParam<number> = this.makeNavigatorWithParam<number>(
    EparcoursPath.root.PARCOURS,
    EparcoursPath.parcours.EDITION,
    PARAM_TOKEN,
    EparcoursPath.parcours.FACTURES,
  );

  tarifsByIdSession: NavigatorWithParam<number> = this.makeNavigatorWithParam<number>(
    EparcoursPath.root.PARCOURS,
    EparcoursPath.parcours.EDITION,
    PARAM_TOKEN,
    EparcoursPath.parcours.TARIFS,
  );

  creation_inscription: NavigatorWithParam<number> = this.makeNavigatorWithParam<number>(
    EparcoursPath.root.PARCOURS,
    EparcoursPath.parcours.EDITION,
    PARAM_TOKEN,
    EparcoursPath.parcours.CREATION_INSCRIPTION,
  );
  creation_multi_inscription: NavigatorWithParam<number> = this.makeNavigatorWithParam<number>(
    EparcoursPath.root.PARCOURS,
    EparcoursPath.parcours.EDITION,
    PARAM_TOKEN,
    EparcoursPath.parcours.CREATION_MULTI_INSCRIPTION,
  );

  edition_facture_brouillon: NavigatorWith2Params<number, number> = this.makeNavigatorWith2Params<number, number>(
    EparcoursPath.root.PARCOURS,
    EparcoursPath.parcours.EDITION,
    PARAM_TOKEN,
    EparcoursPath.parcours.FACTURES,
    EparcoursPath.parcours.EDITION_BROUILLON_FACTURE,
    PARAM_TOKEN,
  );

  visualise_facture_validee: NavigatorWith2Params<number, number> = this.makeNavigatorWith2Params<number, number>(
    EparcoursPath.root.PARCOURS,
    EparcoursPath.parcours.EDITION,
    PARAM_TOKEN,
    EparcoursPath.parcours.FACTURES,
    EparcoursPath.parcours.VISUALISE_FACTURE,
    PARAM_TOKEN,
  );

  resumeByIdSession: NavigatorWithParam<number> = this.makeNavigatorWithParam<number>(
    EparcoursPath.root.PARCOURS,
    EparcoursPath.parcours.EDITION,
    PARAM_TOKEN,
    EparcoursPath.parcours.RESUME_PARCOURS,
  );

  edition_session = this.makeNavigatorWithParam<number>(
    EparcoursPath.root.PARCOURS,
    EparcoursPath.parcours.EDITION,
    PARAM_TOKEN,
    EparcoursPath.parcours.EDITION_SESSION,
  );

  seancesByIdParcours: NavigatorWithParam<number> = this.makeNavigatorWithParam<number>(
    EparcoursPath.root.PARCOURS,
    EparcoursPath.parcours.EDITION,
    PARAM_TOKEN,
    EparcoursPath.parcours.LISTE_SEANCES,
  );
  creation_seance: NavigatorWithParam<number> = this.makeNavigatorWithParam<number>(
    EparcoursPath.root.PARCOURS,
    EparcoursPath.sessions.EDITION,
    PARAM_TOKEN,
    EparcoursPath.sessions.CREATION_SEANCE,
  );
  edition_seance: NavigatorWith2Params<number, number> = this.makeNavigatorWith2Params<number, number>(
    EparcoursPath.root.PARCOURS,
    EparcoursPath.sessions.EDITION,
    PARAM_TOKEN,
    EparcoursPath.sessions.EDITION_SEANCE,
    PARAM_TOKEN,
  );
}
